import { Button, Form, Input, message } from 'antd';
import axios from 'axios';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { baseRoot } from '../../../api/Apis';
import { userLogin } from '../../../api/Services';
import Logo from '../../../assets/image/logo.farescada.png';
import LogoHamrah from '../../../assets/image/logo.png';
import { BasicInput } from '../../../components/Input/input';
import { signIn } from '../../../redux/action/Auth';
import { AUTH_TOKEN, USER_INFO } from '../../../redux/constant';
import { toastMessage } from '../../../utils/Utils';
import { navbar } from '../../../utils/constants';

export const LoginForm = ({ InfoData }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const { data } = await userLogin(values);
      axios.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${data.result.accessToken}`;
      localStorage.setItem(AUTH_TOKEN, data.result.accessToken);
      localStorage.setItem(USER_INFO, JSON.stringify(data.result.user));
      dispatch(signIn(data.result.user));
      const access = data.result.user.access;
      const accessArr = access?.map((str) => str.replace(/_/g, ' '));
      const filteredNavbar = navbar.filter((nav) =>
        accessArr?.includes(nav.name),
      );
      navigate(filteredNavbar[0].href);
      message.success(toastMessage('Login User successfully', 'green'));
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const renderDescriptionContent = ({ title, Owner }) => {
    return (
      <>
        <span className="font-medium text-black">{title}</span>
        <span className="font-medium text-gray-400">Owner : {Owner}</span>
      </>
    );
  };

  return (
    <>
      <img className="w-20 h-6 pb-1" src={Logo} alt="logo" />
      <h1 className="font-bold text-lg justify-start items-start">Login</h1>
      <span className="text-xs">Enter your account information</span>
      <Form
        name="basic"
        form={form}
        labelWrap={false}
        className="text-xs"
        onFinish={handleSubmit}
        layout="vertical"
        requiredMark="optional"
        autoComplete="off"
      >
        <BasicInput
          className="flex font-bold flex-col justify-start items-start"
          name="username"
          label="Username"
          hasFeedback
          rules={true}
          placeholder="Select Username"
        />
        <Form.Item
          className="flex font-bold flex-col justify-start items-start "
          name="password"
          label="Password"
          hasFeedback
          rules={[{ required: true }]}
        >
          <Input.Password
            className="bg-[#EEF0F2] w-44 h-10 border-[#EEF0F2] font-normal text-xs text-[#5B6268] rounded-lg "
            placeholder="Select Password"
          />
        </Form.Item>
        <Form.Item>
          <Button
            loading={loading}
            htmlType="submit"
            className="rounded-2xl mt-5 flex justify-around items-center w-44 h-11 text-xs text-white bg-[#6E6FF7]"
            data-testid="submit-button"
          >
            Sign in
          </Button>
        </Form.Item>
      </Form>
      <div className="md:hidden flex flex-col items-center justify-center">
        <img
          className="w-12 h-12"
          src={
            InfoData?.image ? `${baseRoot}/${InfoData?.image}` : LogoHamrah
          }
        />
        {renderDescriptionContent({
          title: InfoData.plantName,
          Owner: InfoData.ownerName,
        })}
        {/* {InfoData?.description && InfoData?.description.length > 0
          ? InfoData?.description.map((Item) => {
              let title = Item.title1;
              let Owner = Item.Owner;
              return renderDescriptionContent({ title, Owner });
            })
          : renderDescriptionContent({
              title: 'AtrAbad 2 & 3 PowerPlant',
              Owner: 'Mana Mehr Energy Nasim.co',
            })} */}
      </div>
      <div className="pt-3  md:text-sm">
        <img className="w-12 h-12 inline" src={LogoHamrah} />
        {'  '}
        <span className="font-medium text-black text-xs md:text-sm">
          Developed by
        </span>{' '}
        <a
          className="font-semibold text-indigo-700 hover:text-indigo-950 text-xs md:text-sm"
          href="https://farscada.ir/"
          target="blank"
        >
          Farscada.ir
        </a>
      </div>
    </>
  );
};
